import { Container, DisplayObject } from '@tencent/alloy-renderer';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { CANVAS_TABLE_CELL_BG_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { isSameObj } from '@src/js/utils';
import { GraphicsRenderComponent } from '@tencent/alloy-graphics';
import { generateGraphicsModel } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/graphic-adapter/generate-graphics-model';

interface ICellGraphic extends GraphicsRenderComponent {
    id: string,
    frame: { left: number, top: number, width: number, height: number }
}

export class TableBackgroundComponent extends Container {
    private model: ITableModel;

    public constructor() {
        super();
    }

    public updateModel(model: ITableModel): void {
        this.model = model;
        this.updateComponent();
    }

    public getBackgroundCellByRowCol(rowIndex: number, columnIndex: number): DisplayObject | undefined {
        return this.children.find(e => e.id === `${CANVAS_TABLE_CELL_BG_ID_PREFIX}-${rowIndex}-${columnIndex}`);
    }

    // 获取需要渲染的单元格
    private getNeedRenderCells(): Array<{ cell: any, changeSetChanged: boolean }> {
        const cellArr: Array<{ cell: any, changeSetChanged: boolean }> = [];
        this.model.tableItems.forEach((rowInfo, rowIndex) => {
            rowInfo.forEach((cell, cellIndex) => {
                if (!cell.hMerge && !cell.vMerge) {
                    const obj = { changeSetChanged: true, cell };
                    obj.changeSetChanged = this.model.changeSetEngine.hasChangeAtPath(`graphic.graphicData.tbl.tr[${rowIndex}].tc[${cellIndex}]`);
                    cellArr.push(obj);
                }
            });
        });
        return cellArr;
    }

    private updateComponent(): void {
        const needRenderCells = this.getNeedRenderCells();
        const differentNum = needRenderCells.length - this.children.length;

        // 新的单元数量与旧的不一样时，全部清掉重来，因为changeSetEngine判断复杂，暂时简化写法
        if (differentNum !== 0) {
            for (let i = this.children.length - 1; i >= 0; i--) {
                const child = this.children[i];
                child.dispose?.();
                this.removeChild(child);
            }
        }

        // 遍历新的所有单元格
        needRenderCells.forEach((cellInfo, index) => {
            const { cell, changeSetChanged } = cellInfo;
            const bgModel = {
                ...cell.props.style,
                bgShape: ShapeType.rect,
                editable: false,
                selected: false,
            };
            const frame = {
                left: cell.props.style.left,
                top: cell.props.style.top,
                width: cell.props.style.width,
                height: cell.props.style.height,
            };
            if (index < this.children.length) {
                // 对应位置已有旧的单元格
                const child = this.children[index] as ICellGraphic;
                if (!changeSetChanged && isSameObj(frame, child.frame)) {
                    // 判断此单元格未发生更新（背景更新体现在changeSet，坐标大小更新体现在frame）
                    return;
                }
                const graphicsModel = generateGraphicsModel({
                    style: bgModel,
                    frame,
                });
                child.id = `${CANVAS_TABLE_CELL_BG_ID_PREFIX}-${cell.row}-${cell.col}`;
                child.frame = frame;
                child.updateModel(graphicsModel);
            } else {
                // 对应位置没有旧单元格 直接新增
                const graphicsModel = generateGraphicsModel({
                    style: bgModel,
                    frame,
                });
                const child = new GraphicsRenderComponent(graphicsModel) as ICellGraphic;
                child.id = `${CANVAS_TABLE_CELL_BG_ID_PREFIX}-${cell.row}-${cell.col}`;
                child.frame = frame;
                this.addChild(child);
            }
        });
    }
}
